import api from './api';

const pricingService = {
    listProducts: (type) => api.get(`/pricing/stripe-products?type=${type}`),
    createProduct: (type, data) => api.post(`/pricing/stripe-products?type=${type}`, data),
    updateProduct: (type, id, data) => api.put(`/pricing/stripe-products/${id}?type=${type}`, data),
    archiveProduct: (type, id) => api.delete(`/pricing/stripe-products/${id}?type=${type}`),

    createPrice: (type, data) => api.post(`/pricing/stripe-prices?type=${type}`, data),
    updatePrice: (type, id, data) => api.put(`/pricing/stripe-prices/${id}?type=${type}`, data),
    archivePrice: (type, id) => api.delete(`/pricing/stripe-prices/${id}?type=${type}`),

    getPartnerProducts: (type, partnerId) => api.get(`/pricing/partner-products?type=${type}&partnerId=${partnerId}`),
    savePartnerProducts: (type, partnerId, products) => api.put(`/pricing/partner-products?type=${type}`, { partnerId, products }),

    getConfig: (type) => api.get(`/pricing/config?type=${type}`),
    updateConfig: (type, data) => api.put(`/pricing/config?type=${type}`, data),

    resolve: (type, hotelId) => api.get(`/pricing/resolve?type=${type}&hotelId=${hotelId}`),

    getPartnerPlatformProducts: (partnerId) => api.get(`/pricing/partner-platform-products?partnerId=${partnerId}`),
    savePartnerPlatformProducts: (partnerId, productIds) => api.put('/pricing/partner-platform-products', { partnerId, productIds }),

    getAccountProductSeats: (accountId) => api.get(`/pricing/account-product-seats?accountId=${accountId}`),
    saveAccountProductSeats: (accountId, seats) => api.put('/pricing/account-product-seats', { accountId, seats }),

    getFreeSeatCount: (hotelId, productType) => api.get(`/pricing/free-seats?hotelId=${hotelId}&productType=${productType}`),

    getHotelProductSeats: (hotelId) => api.get(`/pricing/hotel-product-seats?hotelId=${hotelId}`),
    saveHotelProductSeats: (hotelId, seats) => api.put('/pricing/hotel-product-seats', { hotelId, seats }),
};

export default pricingService;
